import React, { useState, useEffect, useContext } from "react";
import useSWR from "swr";
import { API_BASE_URL } from "../Config";
import { Alert, Row, Col, Spinner, Container } from "react-bootstrap";
import { CartContext } from "../contexts/CartContext";
import { MaintenanceModeContext } from "../contexts/MaintenanceModeContext";
import { SvgErrorAlert } from "../components/Svgs";
import Product from "../components/Product";
import { useTranslation } from 'react-i18next';

import Banner from "../components/Banner"; 

function HomeScreen() {
  const { t } = useTranslation();
  const fetcher = (url) => fetch(url).then((res) => res.json());
  const { data, error } = useSWR(`${API_BASE_URL}/api/`, fetcher);

  const [isLoading, setIsLoading] = useState(false);
  const maintenanceMode = useContext(MaintenanceModeContext);

  const { products, setProducts, totalPlacedInCart } = useContext(CartContext);

  useEffect(() => {
    setIsLoading(!error && !data);
    if (data) {
      setProducts(data.products);
    }
  }, [data, totalPlacedInCart, error, setProducts]);

  if (maintenanceMode) {
    return <div className="text-center pt-5">{t('website_maintenance')}</div>;
  } else if (isLoading || !products) {
    return (
      <div className="spinning">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </Spinner>
      </div>
    );
  } else {
    return (
      <Container className="pb-3">
        
        <Banner />

        <h3 className="pb-md-1">Home</h3>

        {error && (
          <Alert variant="danger">
            <SvgErrorAlert /> {t('fetch_error')}
          </Alert>
        )}
        {products.length === 0 && (
          <Alert variant="info">
            {t('no_products_available')}
          </Alert>
        )}
        {products && (
          <Row>
            {products.slice(0, 24).map((product) => (
              <Col
                className="my-2 card-border"
                sm={6}
                md={6}
                lg={4}
                xl={3}
                key={product.id}
              >
                <Product key={product.id} product={product} sourceScreen="HomeScreen" />
              </Col>
            ))}
          </Row>
        )}
      </Container>
    );
  }
}

export default HomeScreen;
